import { render, staticRenderFns } from "./GolfConveniosList.vue?vue&type=template&id=9f67004a"
import script from "./GolfConveniosList.vue?vue&type=script&lang=js"
export * from "./GolfConveniosList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports